import React from 'react'
import styled from 'styled-components/macro'
import { TYPE } from '../../theme'

const StyledSwapTitle = styled.div`
  width: 100%;
  margin-top: 114px;
  margin-bottom: 40px;
  text-align: center;
  color: ${({ theme }) => theme.text2};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-top: 78px;
    margin-bottom: 40px;
  `};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin-top: 38.5px;
    margin-bottom: 16px;
  `};
`
const Title = styled(TYPE.main)`
  font-size: 60px;
  margin: auto !important;
  background: linear-gradient(to right, white 50%, ${({ theme }) => theme.primary1});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 448px;
  `};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
     font-size: 32px;
     max-width: 241px;
  `};
`
const SubTitle = styled(TYPE.body)`
  color: ${({ theme }) => theme.text80};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
     font-size: 12px;
  `};
`

export const SwapTitle = () => {
  return (
    <StyledSwapTitle>
      <Title>Trade Smart. Play Hard.</Title>
      <SubTitle>Trade and Own Crypto in Xterio Ecosystem.</SubTitle>
    </StyledSwapTitle>
  )
}
